import script from "./VideoPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoPreview.vue?vue&type=script&setup=true&lang=ts"

import "./VideoPreview.vue?vue&type=style&index=0&id=a081d464&lang=scss&scoped=true"
import "./VideoPreview.vue?vue&type=style&index=1&id=a081d464&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a081d464"]])

export default __exports__